import { Livestock } from "./livestock";
import { StockContractor } from "./stock-contractor";

export class StockGroup {
    id: number;
    name: string;
    stockContractor: StockContractor;
    stockContractorId: number;

    livestock: Livestock[];
}


// WEBPACK FOOTER //
// ./src/model/stock-group.ts